<template>
  <div class="page-wrapper">
    <!-- Theme information -->
    <ThemeBanner :currentLearningType="currentLearningType" :currentTheme="currentTheme" />

    <div class="topic-box hub-grey">
      <template v-if="topicList.length > 0">
        <h1>Table of Contents</h1>
        <p class="hub-subtitle">Please select a topic to begin</p>

        <!-- Topic list -->
        <ul class="topic-list">
          <li
            v-for="topic in topicList"
            :key="topic.id"
            class="topic-wrap hub-link"
            @click="goModuleList(topic)"
            @keypress.enter="goModuleList(topic)"
          >
            <div class="border" />
            <div class="cover" />
            <p>{{ topic.name }}</p>
            <div class="right-arrow" />
          </li>

          <!-- Hold space of last empty li -->
          <li v-if="topicList.length % 2 !== 0" class="topic-wrap space">
            <div class="border" />
          </li>
        </ul>
      </template>
      <h1 v-else>Coming soon</h1>
    </div>

    <!-- TODO -->
    <!-- <div class="view-all-btn btn1 link"
      @click="showModulesOfTheTheme">
      View all Modules
    </div> -->
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { useRouter } from 'vue-router';

import ThemeBanner from '@/components/common/ThemeBanner.vue';
import TopicService from '@/services/topic';
import useSessionStore from '@/stores/session';

const props = defineProps({
  themeId: {
    type: String,
    required: true,
  },
});

const $router = useRouter();
const SessionStore = useSessionStore();
const topicList = ref([]);

const currentLearningType = computed(() => {
  return SessionStore.HUBSettings.currentLearningType;
});

const currentTheme = computed(() => {
  return SessionStore.HUBSettings.currentTheme;
});

async function getTopicList() {
  const data = await TopicService.getTopics(props.themeId);
  topicList.value = data.records;
}

function goModuleList(topic) {
  $router.push({
    name: 'moduleList',
    params: {
      topicId: topic.id,
    },
  });
}

watch(
  () => props.themeId,
  () => {
    getTopicList();
  },
  { immediate: true }
);
</script>

<style scoped>
.page-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.topic-box {
  display: flex;
  flex-direction: column;
  align-items: center;

  box-sizing: border-box;
  position: relative;
  top: 4em;
  width: 100%;
  padding: 2em 1em;
}

.topic-list {
  margin: 2em 0;
  width: 100%;
}

.topic-wrap {
  position: relative;
  width: 100%;
}
.topic-wrap.space {
  display: none;
}

.topic-wrap .border {
  position: absolute;
  left: 0;
  top: 0;
  width: calc(100% - 1px);
  height: calc(100% - 1px);
  border-top: 1px solid #a7a9ac;
  border-bottom: 1px solid #a7a9ac;
}
.topic-wrap .cover {
  position: absolute;
  left: -0.4em;
  top: -1px;
  width: calc(100% + 0.6em);
  height: calc(100%);

  border-radius: 0.5em;
  border: 1px solid #a7a9ac;
  background: #fff;
  box-shadow: 0 0 0.8em 0 #a7a9ac;
  opacity: 0;
  transition: opacity 0.3s;
}
.topic-wrap:hover .cover {
  opacity: 1;
}
.topic-wrap > p {
  display: flex;
  flex-direction: column;
  justify-content: center;

  position: relative;
  margin: 0;
  min-height: 1.8em;
  padding: 1em 2em 1em 0.5em;
  font-size: 1.1em;
}
.topic-wrap .right-arrow {
  position: absolute;
  top: 50%;
  right: 1em;
  transform: translateY(-50%) rotate(-45deg);

  height: 1em;
  width: 1em;
  border-bottom: 1px solid #808285;
  border-right: 1px solid #808285;
}

/** Landscape mobiles */
@media screen and (orientation: landscape) and (min-height: 320px) {
  .topic-box {
    padding: 2em;
  }
}

/** Pads & Landscape big mobiles */
@media screen and (min-width: 768px) and (min-height: 391px) {
  .topic-box {
    top: initial;
  }

  .topic-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;

    margin: 2em 0;
    width: min(90%, 60em);
  }
  .topic-wrap {
    width: 45%;
  }
  .topic-wrap.space {
    display: initial;
  }
}
</style>
